import { useLocation } from "react-router-dom";

/**
 * Rotte senza menu utente: landing, pagina info, login, invito e le due policy.
 *
 * Restano scure in entrambi i temi (identita' marketing, e si vedono prima
 * che l'utente possa scegliere un tema). Il loro contenitore porta la classe
 * `theme-dark-scope`, che ridichiara i token scuri.
 *
 * Serve a chi disegna FUORI da quel contenitore: banner cookie e toast si
 * montano su `document.body`, quindi devono chiedere qui se la pagina sotto
 * e' una di queste e, in tal caso, scurirsi a loro volta.
 */
export const PUBLIC_PATHS = new Set([
	"/",
	"/info",
	"/login",
	"/invite",
	"/privacy-policy",
	"/cookie-policy",
]);

export function useIsPublicRoute() {
	const { pathname } = useLocation();
	return PUBLIC_PATHS.has(pathname);
}
